// removed by extract-text-webpack-plugin
module.exports = {"checkmark":"checkmark","checkmark-content":"checkmark-content","checkmark-icon":"checkmark-icon","selected":"selected"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/checkmark/checkmark.style.sass
// module id = ZpKn
// module chunks = 0